import { queryClient } from "../../../../..";
import {
  __GetContentTypeConfigNew,
  __GetProfileTypeConfig,
} from "../../../../../utils/getters/gettersV2";

const isContentType = (contentType) => {
  const allTpls = queryClient.getQueryData("allTpls");
  const tpl = allTpls.find((d) => d.kp_content_type === contentType);  
  const isContentType = tpl&&["publishing", "collections", "staticPages"].includes(
    tpl.general?.segment
  );
  return isContentType;
};
export const getTagTypeTitle = ({ tagType }) => {
  const isContConf = isContentType(tagType);
  const contConf = isContConf && __GetContentTypeConfigNew(tagType);
  const profileConf = __GetProfileTypeConfig(tagType);

  return contConf
    ? contConf.general.content.title || contConf.kp_content_type
    : (profileConf && profileConf.general?.content.title) || profileConf?.kp_content_type;
};
